import {module as m} from 'modujs';
import gsap from 'gsap';
import {SplitText} from "gsap/SplitText";

gsap.registerPlugin(SplitText);

export default class extends m {
    constructor(m) {
        super(m);
        
        // VAR
        this.delay = parseFloat(this.getData('delay') ? this.getData('delay') : 0);
    }

    init() {
        this.split = new SplitText(this.el, {type: "words", wordsClass: "word"});

        for(let i = 0; i < this.split.words.length; i++) {
            const _word = this.split.words[i];
            _word.style.transitionDelay = ((0.02 * i) + this.delay) + 's';
        }
    }
}
